






























































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";

import DateFormatter from "../../../shared/DateFormatter";
import OverlayWindow from "../../general/OverlayWindow.vue";
import Loading from "../../general/Loading.vue";
import ClientsLogin from "../../clients/public/ClientsLogin.vue";
import ClientsAccountDetails from "../../clients/public/ClientsAccountDetails.vue";

import { SettingsPublicJson } from "../../../shared/SettingsJson";
import ClientJson from "../../../shared/ClientJson";

export default Vue.extend({
  name: "RentalLogin",
  components: {
    OverlayWindow,
    Loading,
    ClientsLogin,
    ClientsAccountDetails,
  },
  props: {
    settings: Object as PropType<SettingsPublicJson | null>,
    clientData: Object,
  },
  data() {
    return {
      RestClient: RestClient,
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      detailsTitle: "Konto",
      user: "" as string,
      password: "" as string,
      loggedIn: undefined as ClientJson | null | undefined,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.loggedIn = this.clientData;
    },

    closeDetails() {
      this.$emit("closeOverlay");
    },

    logout() {
      window.sessionStorage.clear();
      window.localStorage.clear();
      location.reload();
    },

    register() {
      this.loggedIn = null;
      this.password = "";
      this.$emit("changeClientData", this.loggedIn);
    },
  },

  watch: {
    clientData() {
      this.loggedIn = this.clientData;
    },
  },

  computed: {},
});
